/**
 * The ClientMa lockup, as supplied.
 *
 * `web/assets/logo.png` is the full lockup — the CM monogram, the ClientMa wordmark and the
 * "Client Management Platform" line — so nothing here adds a wordmark of its own. Doing so
 * would print the product name twice.
 *
 * `favicon.png` is the monogram alone. It is used where the full lockup would be illegible:
 * the dark footer, where the navy wordmark all but disappears.
 *
 * Both come from the shared asset folder, which Vite serves as the site's public directory.
 */

/** Header and anywhere else on a light surface. */
export function Brand({ href = '/' }: { href?: string }) {
  return (
    <a className="brand" href={href} aria-label="ClientMa — home">
      <img
        className="brand__logo"
        src="/logo.png"
        alt="ClientMa — Client Management Platform"
        width={156}
        height={120}
      />
    </a>
  );
}

/**
 * The monogram, with the name set in the page's own type.
 *
 * For dark surfaces: the supplied lockup's wordmark is navy, which is unreadable on the footer,
 * so the mark is kept and the words are rendered in white beside it.
 */
export function BrandOnDark({ href = '/' }: { href?: string }) {
  return (
    <a className="brand brand--dark" href={href} aria-label="ClientMa — home">
      <img className="brand__mark" src="/favicon.png" alt="" width={64} height={64} />
      <span>
        <span className="brand__name">ClientMa</span>
        <span className="brand__by">by SJS Tech</span>
      </span>
    </a>
  );
}
